import { mean } from "lodash-es";

import type {
  OutcomeAssessmentType,
  PageGroupUserType,
  PageType,
  SubmissionType,
} from "components/server-types";
import { isGroupPage } from "utils/page-utils";

export const LAST_ASSESSMENT_PANEL_ACCESS_ID = "last-panel";

export const getMedianScore = (scores: number[]) => {
  const sorted = scores.sort((a, b) => a - b);
  return sorted[Math.floor(sorted.length / 2)];
};

export const getMeanScoreByPageOutcomeId = (outcomeAssessments: OutcomeAssessmentType[]) => {
  const scoresByPageOutcomeId = outcomeAssessments.reduce(
    (acc, oa) => ({ ...acc, [oa.page_outcome_id]: [...(acc[oa.page_outcome_id] || []), oa.score] }),
    {} as { [pageOutcomeId: string]: number[] },
  );
  return Object.entries(scoresByPageOutcomeId).reduce(
    (acc, [pageOutcomeId, scores]) => {
      return { ...acc, [pageOutcomeId]: mean(scores) };
    },
    {} as { [pageOutcomeId: string]: number },
  );
};

export const getTotalSubmissions = (
  page: PageType,
  submissions: SubmissionType[],
  enabledPageGroupUsers: PageGroupUserType[] = [],
) => {
  if (isGroupPage(page)) {
    // Get unique page_group_ids that have enabled users
    const groupsWithEnabledUsers = new Set(enabledPageGroupUsers.map((pgu) => pgu.page_group_id));

    // Only count groups that have submissions AND have enabled users
    return new Set(
      submissions
        .filter((s) => groupsWithEnabledUsers.has(s.page_group_id!))
        .map((s) => s.page_group_id),
    ).size;
  }

  return new Set(submissions.map((s) => s.course_user_id)).size;
};
